/*!
 * Javascript
 * ---------------------------------------------------------------------------------
 */
global.jQuery = global.$ = require('jquery');
global.Masonry = require('masonry-layout');

require('slick-carousel');
require('@fancyapps/fancybox');

let body = $('body'),
  bodyClassAdded = false,
  blocks = document.querySelector('.blocks');

let scroll = e => {
  if (window.scrollY > 0 && bodyClassAdded) {
    return;
  }

  if (window.scrollY <= 0) {
    body.removeClass('scroll');
    bodyClassAdded = false;
    return;
  }

  body.addClass('scroll');
  bodyClassAdded = true;
};

document.addEventListener('scroll', scroll);

scroll();

let masonInit = () => {
    blocks.className += ' mason'

    return new Masonry(blocks, {
      itemSelector: '.blocks__grid',
      transitionDuration: 0,
      columnWidth: '.blocks__grid--small'
      //horizontalOrder: true
    });
  },
  masonTimeout;

let carousels = $('.carousel,.slides__inner');

carousels.each((i, item) => {
  //clearTimeout(masonTimeout);

  setTimeout(() => {
    clearTimeout(masonTimeout);

    $(item).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5800 + ((Math.floor(Math.random() * 12) + 1) * 100),
      arrows: false,
      touchThreshold: 100,
      speed: 520,
      pauseOnHover: false,
      cssEase: 'cubic-bezier(.37,1.02,.36,1.04)'
    });

    masonTimeout = setTimeout(masonInit, 500);

  }, (Math.floor(Math.random() * 20) + 1) * 100)
});

if (!carousels.length) {
  masonInit();
}

$(document).on('click', '.banner__trigger', (e) => {
  e.preventDefault();

  if (!body.hasClass('show-sidebar')) {
    $([document.documentElement, document.body]).animate({
      scrollTop: $('.roomgrid').offset().top - 50
    }, 330);
  }

  body.toggleClass('show-sidebar');
})

let bookingform = $('.bookingform');

$('.bookingform select').change(() => {
  if (!bookingform[0].checkValidity()) return;

  $.ajax({
    type: 'POST',
    url: bookingform[0].action,
    data: bookingform.serialize(),
    cache: false,
    success: function (data) {
      $('.bookingprice').replaceWith(data);
    }
  });
})
